/* eslint-disable no-nested-ternary */
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 0;
`;

export const BlockContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const getBorderColor = ({ isDisabled, isApproved, isDeleted }) => {
  if (isDeleted) return '#C12335';
  if (isDisabled) return '#cdcdcd';
  if (!isApproved) return '#FACA69';
  return '#4b286d';
};

const getBackgroundColor = ({ isDisabled, isApproved, isDeleted }) => {
  if (isDeleted) return '#FFF6F8';
  if (isDisabled) return '#FCFCFC';
  if (!isApproved) return '#FFF9EE';
  return '#FFFFFF';
};

export const BlockItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem;
  border: 1px solid ${props => getBorderColor(props)};
  background-color: ${props => getBackgroundColor(props)};
  border-radius: 1rem;
  position: relative;
  overflow: hidden;
`;

export const BlockItemHead = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 1rem;
  opacity: ${prop => (prop.greyOut ? '0.5' : 1)};
`;

export const BlockTitle = styled.p`
  justify-self: start;
  font-size: 18px;
  font-weight: 600;
  color: ${prop => (prop.isDisabled ? '#71757B' : '#4b286d')};
`;

export const Email = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: ${prop => (prop.isDisabled ? '#71757B' : '#2b8000')};
  margin-top: 0.25rem;
  word-break: break-all;
`;

export const RoleLabel = styled.p`
  background: #f2eff4;
  color: #4b286d;
  border: 1px solid #adadad;
  padding: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0px;
`;

export const TopBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`;

export const EditOverlay = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  justify-content: ${props => (props.center ? 'center' : 'flex-start')};
`;

export const PendingApprovalLabel = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #4b286d;
  align-items: ${props => (props.center ? 'center' : 'flex-start')};
`;

export const ApproveButton = styled.button`
  padding: 0.5rem 1.5rem;
  border: 1px solid #4b286d;
  background: transparent;
  color: #4b286d;
  font-size: 13px;
  font-weight: 700;
  border-radius: 1rem;

  &:hover {
    background: #4b286d;
    color: #fff;
  }
`;

export const DeclineButton = styled.button`
  padding: 0.5rem 1.5rem;
  border: 1px solid #c12335;
  background: transparent;
  color: #c12335;
  font-size: 13px;
  font-weight: 700;
  border-radius: 1rem;

  &:hover {
    background: #c12335;
    color: #fff;
  }
`;

export const UserDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 3rem;
  border-radius: 0;
`;

export const BackButton = styled.button`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 1rem;
  background: transparent;
  border: 0;
  text-decoration: underline;
  fontsize: 18px;
`;

export const ErrorText = styled.p`
  color: #c12335;
  margin-top: 1rem;
  font-size: 14px;
  font-weight: 700;
`;
